import { ExperienceId } from '@a_team/models/dist/ExperienceObject';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const experiencesKeys = createQueryKeys('experiences', {
  byUserId: (userId: string) => ({
    userId,
  }),
  experiencesCompletenessScoreByUserId: (userId: string) => ({
    type: 'experiencesCompletenessScoreByUserId',
    userId,
  }),
  hasPendingCollaboratorRequest: (userId: string, eid: string) => ({
    userId,
    eid,
  }),
  experiencesMatchesOnData: (eids: ExperienceId[]) => ({
    eids,
  }),
});
